import { Component, OnInit,Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CommonServices } from 'src/app/Services/common.service';
import { ApiService } from '../../../../../../Services/api.service';
import { StorageService } from '../../../../../../Services/storage.service';
import { SweetAlert } from '../../../../../../Services/sweetalet.service';
declare const Swal;

@Component({
  selector: 'app-view-manage-vehicle-driver',
  templateUrl: './view-manage-vehicle-driver.component.html',
  styleUrls: ['./view-manage-vehicle-driver.component.css']
 
})
export class ViewManageVehicleDriverComponent implements OnInit {
  @Input() _activeMenu: string = '';

  public breadcrumbData = {
    "Information": "/organization/transport-manager/information",
    "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
  };
  public vendorID = '';
  public routerLinkStr = '';

  public enableTable:boolean = true;

  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';
  public unassignVehSrchVal = '';
  public unassignDriSrchVal = '';

  activeModule:string = 'assignvehicleValues';
  
  // upload files

  public xlFileName:any = '';
  public enableFileName:boolean = false;

  public closeExlUploadAlert:boolean = true;
  public exlUploadPopup:boolean = true;
  public exlUploadRes:any;
  public exlUploadTable = [
    { key: 'vehRegNo', display: 'Vehicle Reg no' , config:{ isVehicle:true,}, },
    { key: 'model', display: 'Vehicle Model' },
    { key: 'driverName', display: 'Driver Name' },
    { key: 'action', display: 'Action' },
  ]


  constructor(
    public storage: StorageService, 
    public router: Router,
    public route: ActivatedRoute,
    public api: ApiService,
    public swal :SweetAlert,
    public comService: CommonServices,
) {
  
  let vendorName = this.storage.get('vendorID_orgID')['vendorName'];
  this.route.paramMap.subscribe((params: any) => {
    this.vendorID=params.params.vendorID;
    if(vendorName){
      vendorName = this.comService.strTruncate(vendorName,13);
      this.breadcrumbData[vendorName] =  "/organization/transport-manager/information/vendor/single-view-vendor/"+this.vendorID;
    }else{
      this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/"+this.vendorID;
    }
    this.breadcrumbData['Manage'] = "";

  });
}

  ngOnInit(): void {
    this.routerLinkStr = `/organization/transport-manager/information/manage/manage-vehicle/${this.vendorID}`;
  }
     // search
     onSearchChange(searchValue: string) {

      searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');
  
      if (!this.searchChangeObserver) {
        new Observable(observer => {
          this.searchChangeObserver = observer;
        }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
          // .pipe(distinctUntilChanged()) // only emit if value is different from previous value
          .subscribe((term: any) => {
            // your code here
            if(this.activeModule == 'assignvehicleValues'){
              this.searchInputValue = term;
            }else if(this.activeModule == 'unassignVehicle'){
              this.unassignVehSrchVal = term;
            }else if(this.activeModule == 'unassignDriver'){
              this.unassignDriSrchVal = term;
            }
            // if(String(term).length==0) this.getManageList(1,this.paginationData.limit,term);
            // else if(String(term).length>=2) this.getManageList(1,this.paginationData.limit,term);
          });
      }
  
      this.searchChangeObserver.next(searchValue);
    }

    changeTable(type){
      (document.getElementById('searchInputField') as HTMLInputElement).value = '';
      this.searchInputValue = '';
      this.unassignVehSrchVal = '';
      this.unassignDriSrchVal = '';
      this.activeModule = type;
    }
  
downloadTemplate(){
  document.getElementById('excelTemplate').click();
}

  uploadExcelFile(){
    document.getElementById('manageVehicleListExcelUpload').click();
  }
  uploadManageList(event){
    this.xlFileName = event.target.files[0].name;
    this.enableFileName = true;
    let apiObj ={
      vendorID:this.vendorID
    }; 
    let url = 'organization/excel/addDriver';
    
     this.api.xlsxFileUpload(apiObj,url,'manageVehicleListExcelUpload',(res: any)=>{   
      if((res.responseJSON.exitsData && res.responseJSON.exitsData != {}) || (res.responseJSON.validationFails && res.responseJSON.validationFails !={})){
        this.exlUploadRes = res.responseJSON;
        this.closeExlUploadAlert = false;
      }
      else if(res.responseJSON.status=='success' && res.responseJSON.message){
        this.swal.swalFunction(res.responseJSON.status, res.responseJSON.status, res.responseJSON.message, 5000);
        Swal.fire(  'Good job!',  'You clicked the button!',  'success')
      }
      else if(res.responseJSON.status=='failure'){
        this.swal.swalFunction(res.responseJSON.status, res.responseJSON.status, res.responseJSON.message, 10000);
      }
      let doc: any=  document.getElementById('manageVehicleListExcelUpload');
      doc.value = '';
      
     });  
  }

}
